<app-dialog-header [title]="title" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div class="p-24" fxLayout="column" fxLayoutAlign="start">
    <form [formGroup]="programCompletionForm" class="w-100-p offering-category-form completion-rules-form" fxLayout="column">
        <div class="checkbox-wrapper">
            <h3 class="completion-rules-title mt-0 mb-8">{{ text | translate }}</h3>
            <mat-radio-group fxLayout="column" formControlName="completion_rule_category" (change)="handleCompletionRuleCategoryChange($event)">
                <mat-radio-button class="completion-rule-option" [value]="completionRuleOpts.MANUALLY">
                    {{ manuallyLabelKey | translate }}
                </mat-radio-button>
                <mat-radio-button class="completion-rule-option" [value]="completionRuleOpts.UNDEFINED">
                    {{ automaticallyLabelKey | translate }}
                </mat-radio-button>

                <mat-radio-group class="automatic-rules-group" formControlName="completion_rule" (change)="handleCompletionRuleChange()">
                    <div fxLayout="column" *ngFor="let completionRule of automaticallyBySetRulesOptions">
                        <mat-radio-button class="completion-rule-option" [value]="completionRule.value" [disabled]="!isAutomaticCompletionSelected">
                            {{ completionRule.translationLabel | translate }}
                        </mat-radio-button>

                        <div class="nested-fields-wrapper" *ngIf="completionRule.value === completionRuleOpts.SECTIONS && showSectionsFields">
                            <mat-form-field class="w-100-p" subscriptSizing="dynamic">
                                <mat-label>{{ 'COURSES.COMPLETION_RULE.WHICH_SECTIONS' | translate }}</mat-label>
                                <mat-select
                                    formControlName="selected_section"
                                    (selectionChange)="handleSelectedSectionChange()"
                                    [disabled]="!isAutomaticCompletionSelected"
                                    required
                                >
                                    <mat-option value="all">{{ 'COURSES.COMPLETION_RULE.ALL_SECTIONS' | translate }}</mat-option>
                                    <mat-option value="percentage">{{ 'COURSES.COMPLETION_RULE.PERCENTAGE_OF_SECTIONS' | translate }}</mat-option>
                                    <mat-option value="mandatory" *ngIf="module.sectionRule === SectionRule.Sequential">
                                        {{ 'SECTION.LABEL.MANDATORY_SECTIONS' | translate }}
                                    </mat-option>
                                    <mat-option [value]="section.id" *ngFor="let section of moduleSections">
                                        {{ 'COURSES.COMPLETION_RULE.SPECIFIC_SECTION' | translate: { sectionName: section.name } }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <mat-form-field class="w-100-p" subscriptSizing="dynamic" *ngIf="showPercentageField">
                                <mat-label>{{ 'COURSES.COMPLETION_RULE.PERCENTAGE_OF_SECTIONS_LABEL' | translate }}</mat-label>
                                <input
                                    matInput
                                    type="number"
                                    formControlName="sections_completion_percentage"
                                    min="1"
                                    max="100"
                                    required
                                    (input)="clampPercentageValue('sections_completion_percentage')"
                                />
                                <span matTextSuffix>%</span>
                            </mat-form-field>
                        </div>

                        <mat-checkbox
                            class="min-attendance-option"
                            *ngIf="showAllCoursesMinAttendanceCheckbox && completionRule.value === completionRuleOpts.AUTO_COMPLETE_ALL_COURSES"
                            [formControl]="allCoursesAndMinAttendanceReach"
                            [disabled]="!isAutomaticCompletionSelected"
                            (change)="onMinAttendanceCheckboxChange()"
                        >
                            {{ 'PROGRAM_OFFERING.COMPLETION_RULE.ATTENDANCE.BY_REACING_MINIMUM_ATTENDANCE_REQUIREMENT' | translate }}
                        </mat-checkbox>

                        <div
                            class="nested-fields-wrapper"
                            *ngIf="
                                showMinimumAttendanceField &&
                                showAllCoursesMinAttendanceCheckbox &&
                                completionRule.value === completionRuleOpts.AUTO_COMPLETE_ALL_COURSES
                            "
                        >
                            <mat-form-field class="w-100-p percentage-field" subscriptSizing="dynamic">
                                <mat-label>{{ 'COURSES.COMPLETION_RULE.MINIMUM_ATTENDANCE' | translate }}</mat-label>
                                <input
                                    matInput
                                    type="number"
                                    formControlName="minimum_attendance"
                                    min="1"
                                    max="100"
                                    required
                                    (input)="clampPercentageValue('minimum_attendance')"
                                />
                                <span matTextSuffix>%</span>
                            </mat-form-field>
                        </div>

                        <mat-checkbox
                            class="min-attendance-option"
                            *ngIf="showEndDateMinAttendanceCheckbox && completionRule.value === completionRuleOpts.AUTO_END_DATE_REACHED"
                            [formControl]="autoEndDateReachAndMinAttendanceReached"
                            [disabled]="!isAutomaticCompletionSelected"
                            (change)="onMinAttendanceCheckboxChange()"
                        >
                            {{ 'PROGRAM_OFFERING.COMPLETION_RULE.ATTENDANCE.BY_REACING_MINIMUM_ATTENDANCE_REQUIREMENT' | translate }}
                        </mat-checkbox>

                        <div
                            class="nested-fields-wrapper"
                            *ngIf="
                                showMinimumAttendanceField &&
                                showEndDateMinAttendanceCheckbox &&
                                completionRule.value === completionRuleOpts.AUTO_END_DATE_REACHED
                            "
                        >
                            <mat-form-field class="w-100-p percentage-field" subscriptSizing="dynamic">
                                <mat-label>{{ 'COURSES.COMPLETION_RULE.MINIMUM_ATTENDANCE' | translate }}</mat-label>
                                <input
                                    matInput
                                    type="number"
                                    formControlName="minimum_attendance"
                                    min="1"
                                    max="100"
                                    required
                                    (input)="clampPercentageValue('minimum_attendance')"
                                />
                                <span matTextSuffix>%</span>
                            </mat-form-field>
                        </div>

                        <div
                            class="nested-fields-wrapper attendance-fields"
                            fxLayout="row"
                            fxLayoutAlign="start center"
                            fxLayoutGap="16px"
                            *ngIf="completionRule.value === completionRuleOpts.AUTO_MIN_ATTENDANCE_REACHED && showCourseMinimumAttendanceField"
                        >
                            <mat-form-field class="min-attendance-field" subscriptSizing="dynamic" fxFlex>
                                <mat-label>{{ 'COURSES.COMPLETION_RULE.MINIMUM_ATTENDANCE' | translate }}</mat-label>
                                <input
                                    matInput
                                    type="number"
                                    formControlName="minimum_attendance"
                                    min="1"
                                    max="100"
                                    required
                                    (input)="clampPercentageValue('minimum_attendance')"
                                />
                                <span matTextSuffix>%</span>
                            </mat-form-field>

                            <button type="button" class="settings-link" (click)="openSettings()">
                                <span>{{ 'COURSES.COMPLETION_RULE.CHANGE_IN_SETTINGS' | translate }}</span>
                                <mat-icon class="icon-18 ml-2">chevron_right</mat-icon>
                            </button>
                        </div>
                    </div>
                </mat-radio-group>
            </mat-radio-group>
        </div>
    </form>
</div>

<div class="pt-24 action-buttons" fxLayout="row" fxLayoutAlign="end center">
    <app-white-button class="mr-8" [label]="'GENERAL.BUTTON.CANCEL'" (onClick)="dialogRef.close(false)"></app-white-button>
    <app-flat-button [label]="'GENERAL.BUTTON.SAVE'" [disabled]="isSaveDisabled" (onClick)="onSaveProgramCompletion()"></app-flat-button>
</div>
